import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import 'tdesign-react/es/style/index.css'; // 少量公共样式
import { createGlobalStyle } from 'styled-components';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import 'animate.css';
import { scrollBarMixin } from './utils/mixinStyle';

function App({ clientHeight }) {
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  // 暂无首页，直接跳转登录页面
  useEffect(() => {
    if (pathname === '/') {
      let url = '/login';
      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
      navigate(url);
    }
  }, [pathname, navigate, params]);

  return (
    <>
      <GlobalStyle clientHeight={clientHeight} />
      <Outlet />
    </>
  );
}

export default connect((state) => ({
  clientHeight: state.layout.clientHeight,
}))(App);

const GlobalStyle = createGlobalStyle`
  :root {
    --td-radius-default: 6px;
  }
  :root,
  :root[theme-mode="light"] {
    --td-brand-color-7: #194dff;
    --td-font-gray-1: #0D111A;
    --td-font-gray-2: rgba(32, 43, 64, 0.5);
  }

  /* 
    Radio Group 按钮风格
    简单的css hack方案
    注意在variant="primary-filled"下使用
  */
  .hack_radio_button_theme {
    .t-radio-button {
      padding-left: 12px !important;
      padding-right: 12px !important;
    }
    .t-radio-group.t-radio-group--filled {
      background-color: transparent;
    }
    .t-radio-group.t-radio-group--primary-filled .t-radio-button.t-is-checked {
      color: var(--td-brand-color);
    }
    .t-radio-group__bg-block {
      border: 1px solid var(--td-brand-color);
      box-sizing: border-box;
      background-color: transparent !important;
      border-radius: 6px !important;
      &[style*="width: 0px"] {
        border: none;
      }
    }
  }

  .hide {
    display: none;
  }

  @keyframes antStatusProcessing {
    0% {
        transform: scale(.8);
        opacity: .5
    }

    to {
        transform: scale(2.4);
        opacity: 0
    }
}

  @keyframes fadeIn {
    0% {opacity: 0;}
    100% {opacity: 1;}
  }
  .fadeIn {
    animation-name: fadeIn;
    animation-timing-function: ease-in;
    animation-duration: .2s;
  }

  .t-dialog.json-code-dialog {
    .t-dialog__body {
    }
    .__json-pretty__ {
      margin: 0 !important;
      height: ${(props) => props.clientHeight - 260}px !important;
      padding: 20px;
      overflow: auto;
      border-radius: 6px;
      ${scrollBarMixin};
      ::-webkit-scrollbar-thumb {
        background-color: #fff;
      }
    }
  }

  .t-table {
    th {
      color: var(--td-font-gray-1);
      font-weight: bold;
    }

    /* 特殊优化 */
    .optimize-hide {
      display: none;
    }
  }
  .t-table__header--fixed:not(.t-table__header--multiple) > tr > th {
    background-color: rgb(250, 250, 250);
  }

  .t-loading__parent {

    .t-table__footer, .t-table__header.t-table__header--fixed {
      z-index: 1;
    }
  }

  // 滚动条优化
  .t-drawer__body {
    ${scrollBarMixin};
  }

  .t-loading--full {
    z-index: 1;
  }
  
`;
